import React from 'react';
import Link from './Link';

export default function BasicLink({
  className = '',
  ...props,
}) {
  return (
    <Link className={`basic-link ${className}`} {...props} />
  );
}



// WEBPACK FOOTER //
// ./src/universal/ui/components/BasicLink.js